// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Clientes_DuplicateDocumentResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { Clientes_ClienteRow } from './Clientes_ClienteRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Clientes_DuplicateDocumentResponseDados {
existing_cliente: Clientes_ClienteRow
}

export type Clientes_DuplicateDocumentResponse = ApiResponse<Clientes_DuplicateDocumentResponseDados>;

registerResponseContract('Clientes_DuplicateDocumentResponse', {
  existing_cliente: {
    type: 'object',
    required: true,
    fields: {
      cliente_id:                              { type: 'number',  required: false },
      cliente_nome:                            { type: 'string',  required: false },
      cliente_cpf:                             { type: 'string',  required: false },
      cliente_document_type:                   { type: 'string',  required: false },
      cliente_email:                           { type: 'string',  required: false },
      cliente_data_nascimento:                 { type: 'string',  required: false },
      cliente_genero:                          { type: 'string',  required: false },
      cliente_ddi:                             { type: 'string',  required: false },
      cliente_ddd:                             { type: 'string',  required: false },
      cliente_telefone:                        { type: 'string',  required: false },
      cliente_cep:                             { type: 'string',  required: false },
      cliente_rua:                             { type: 'string',  required: false },
      cliente_numero:                          { type: 'string',  required: false },
      cliente_complemento:                     { type: 'string',  required: false },
      cliente_bairro:                          { type: 'string',  required: false },
      cliente_location_id:                     { type: 'number',  required: false },
      cliente_location_type:                   { type: 'string',  required: false },
      cliente_franquia_id:                     { type: 'number',  required: false },
      cliente_obs:                             { type: 'string',  required: false },
      cliente_data_cadastro:                   { type: 'string',  required: false },
      cliente_status:                          { type: 'number',  required: false },
      cliente_cidade_id:                       { type: 'number',  required: false },
      cliente_link_conversa:                   { type: 'string',  required: false },
      cliente_origem_id:                       { type: 'number',  required: false },
      cliente_data_ultimo_compromisso:         { type: 'string',  required: false },
      cliente_data_ultimo_orcamento:           { type: 'string',  required: false },
      cliente_qtd_compromissos:                { type: 'number',  required: false },
      cliente_data_ultimo_contato_fidelizacao: { type: 'string',  required: false },
      cliente_categoria:                       { type: 'string',  required: false },
      cliente_profissao:                       { type: 'string',  required: false },
    },
  },
})
